import React from 'react';
import { CellContainer, CellIcon, Row } from '@bit/knotchinc.web-react-components.table-sync';
import RemoveEntityButton from '../RemoveEntityButton.jsx';

export const SubscriptionRow = props => {
  let subscriptionData;

  if (!props.header) {
    const { name, logo_url, public_id } = props.data;
    subscriptionData = {
      name,
      image_url: logo_url,
      link: `/blueprint/brands/${public_id}`,
    };
  }

  return (
    <Row {...props}>
      <CellIcon data={subscriptionData} headerText="Subscription" width={0.8} />
      <CellContainer width={0.2}>
        {!props.header && <RemoveEntityButton type="subscription" id={props.data.public_id} />}
      </CellContainer>
    </Row>
  );
};
